import { SVGProps } from "react";
import styles from "./styles.module.scss";
import messages from "messages";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

const CustomReferenceLine = (rest: SVGProps<SVGLineElement>) => {
  const { x1, x2, y1, y2, y, ...props } = rest;

  return (
    <g transform={`translate(0,${y1})`}>
      <line
        {...props}
        className={styles["custom-reference-line__line"]}
        x1={((x1 as undefined | number) ?? 0) - 34}
        x2={((x2 as undefined | number) ?? 0) + 20}
        y1={0}
        y2={0}
      />
      <text
        x={(x2 as number) + 20 + 8}
        y={4}
        className={styles["custom-reference-line__label"]}
        textAnchor="start"
      >
        {messages.avg}
      </text>
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip
            id="custom-reference-line-tooltip"
            className={styles["custom-reference-line__tooltip"]}
          >
            {"$" + y}
          </Tooltip>
        }
      >
        <g transform={`translate(${(x2 as number) + 20 + 8 + 22},-8)`}>
          {/* expand some tooltip space */}
          <rect width={16} height={16} rx={8} fillOpacity={0} />
          <path
            d="M7.25 11.3333C7.25 11.7475 7.58579 12.0833 8 12.0833C8.41421 12.0833 8.75 11.7475 8.75 11.3333H7.25ZM8.75 6.66667C8.75 6.25245 8.41421 5.91667 8 5.91667C7.58579 5.91667 7.25 6.25245 7.25 6.66667L8.75 6.66667ZM7.25 4.67331C7.25 5.08752 7.58579 5.42331 8 5.42331C8.41421 5.42331 8.75 5.08752 8.75 4.67331H7.25ZM8.75 4.66665C8.75 4.25243 8.41421 3.91665 8 3.91665C7.58579 3.91665 7.25 4.25243 7.25 4.66665H8.75ZM8.75 11.3333L8.75 6.66667L7.25 6.66667L7.25 11.3333H8.75ZM8.75 4.67331V4.66665H7.25V4.67331H8.75ZM13.25 8C13.25 10.8995 10.8995 13.25 8 13.25V14.75C11.7279 14.75 14.75 11.7279 14.75 8H13.25ZM8 13.25C5.10051 13.25 2.75 10.8995 2.75 8H1.25C1.25 11.7279 4.27208 14.75 8 14.75V13.25ZM2.75 8C2.75 5.10051 5.10051 2.75 8 2.75V1.25C4.27208 1.25 1.25 4.27208 1.25 8H2.75ZM8 2.75C10.8995 2.75 13.25 5.10051 13.25 8H14.75C14.75 4.27208 11.7279 1.25 8 1.25V2.75Z"
            fill="var(--primary)"
          />
        </g>
      </OverlayTrigger>
    </g>
  );
};

export default CustomReferenceLine;
